import { CommonActions } from '@react-navigation/native';

let navigator;

export function setNavigator(nav) {
  navigator = nav;
}

export function navigate(name, params) {
  if (navigator) {
    navigator.dispatch(
      CommonActions.navigate({
        name,
        params,
      })
    );
  }
}

export function goBack() {
  if (navigator && navigator.canGoBack()) {
    navigator.goBack();
  }
}

export function resetToScreen(name, params = {}) {
  if (navigator) {
    navigator.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [{ name, params }],
      })
    );
  }
}

export function getCurrentRoute() {
  if (navigator) {
    return navigator.getCurrentRoute();
  }
  return null;
}

export function canGoBack() {
  return navigator && navigator.canGoBack();
} 